import {
  Icon,
  IconColor,
  IconName,
  IconSize,
  Text,
  TextHighlight,
  TextSize,
  TextWeight
} from '@focaldata/cin-ui-components'
import DragAndDrop from '../../../components/DragAndDrop-react-dnd/DragAndDrop'
import { Destination, Source } from '../../Questionnaire/useDragAndDrop.hooks'
import useStyles from './ReorderAudienceDialog.styles'

export const REORDER_DRAG_TYPE = 'audienceOrder'

interface Props {
  memberId: string
  index: number
  /** undefined for a criterion respondents are never asked */
  label: string | undefined
  text: string
  scrollContainerSelector: string
  onMove: (memberId: string, toIndex: number) => void
}

const ReorderAudienceRow = ({
  memberId,
  index,
  label,
  text,
  scrollContainerSelector,
  onMove
}: Props) => {
  const { classes, cx } = useStyles()
  const isNotAsked = label === undefined

  return (
    <DragAndDrop
      position={index}
      id={memberId}
      path={memberId}
      type={REORDER_DRAG_TYPE}
      accept={[REORDER_DRAG_TYPE]}
      draggable
      scrollContainerSelector={scrollContainerSelector}
      moveCard={(itemId: string, _source: Source, dest: Destination) =>
        onMove(itemId, dest.position)
      }
    >
      <div className={cx(classes.row, isNotAsked && classes.rowNotAsked)}>
        <div className={classes.label}>
          <Text
            size={TextSize.ms}
            weight={TextWeight.SemiBold}
            highlight={TextHighlight.Background}
          >
            {label ?? ''}
          </Text>
        </div>
        <div className={classes.title}>
          <Text size={TextSize.ms}>{text}</Text>
        </div>
        {isNotAsked && (
          <Text size={TextSize.s} className={classes.notAsked}>
            Not asked
          </Text>
        )}
        <Icon
          name={IconName.DragIndicator}
          iconColor={IconColor.Background}
          size={IconSize.Medium}
        />
      </div>
    </DragAndDrop>
  )
}

export default ReorderAudienceRow
